import styled from "styled-components";

export const Medical = styled.div`
  .active {
       background: #f1fff7;
    border: 1px solid #44b878;
}
  }
`;
